import EXTERNAL_SERVICES_CONFIG from './externalServicesConfig'

export const API_CONFIG = {
  BASE_URLS: {
    PAYMENT: EXTERNAL_SERVICES_CONFIG.PAYMENT_HOST,
    API: EXTERNAL_SERVICES_CONFIG.API_HOST,
    DATA_STORE: EXTERNAL_SERVICES_CONFIG.DATA_STORE_HOST,
  },

  GROUP: EXTERNAL_SERVICES_CONFIG.DEFAULT_GROUP,

  SERVICES: {
    RAPIDOO_DATA_MOCK: 'rapidoo-data-mock',
    RAPIDOO_RESTAURANT_KYC: 'rapidoo-restaurant-kyc',
    RAPIDOO_RIDER_KYC: 'rapidoo-rider-kyc',
  },

  ENDPOINTS: {
    STORE_DATA: '/store/app/data',
    PARTIAL_SAVE: '/data-store-partial-saver/store/app/data',
    CUSTOMER_LIST: '/customer/list/',
    CUSTOMER_DELETE: '/customer/delete/customer/',
    RIDER_LIST: '/riders/riders/',
    RIDER_CREATE: '/riders/rider',
    RIDER_DELETE: '/riders/rider/delete/',
    RIDER_DELIVERIES: '/riders/deliveries/',
    WALLET_CREDIT: '/wallet/credit',
    PAYMENTS_LIST: '/rapidoo-apis-prototype/payments/list?storeId=',
    PAYMENT_SEARCH: '/rapidoo-transaction-search/search',
    STATS_CUSTOMER: '/stats',
    STATS_ORDER: '/stats',
    STATS_PAYMENT: '/stats',
    WALLET_BALANCE: '/wallet/balance',
    DEALS_LIST: '/deals/deal?onlyActive=true&storeId=',
    DEALS_CREATE: '/deals/deal',
    DEALS_UPDATE: '/deals/deal/',
    DEALS_DELETE: '/deals/deal/',
    PRODUCT_LIST: '/product/list/',
  },

  TIMEOUT: 30000,
  DEFAULT_USER_ID: 'rapidoo-data-mock',
}

export function buildApiUrl(baseUrl, endpoint, params = {}) {
  const url = new URL(endpoint, baseUrl)
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, value)
    }
  })
  return url.toString()
}

export function buildStoreDataUrl(params = {}) {
  const {
    service = API_CONFIG.SERVICES.RAPIDOO_DATA_MOCK,
    group = API_CONFIG.GROUP,
    userId,
  } = params
  const queryParams = new URLSearchParams({
    service,
    group,
    ...(userId && { userId }),
  })
  return `${API_CONFIG.BASE_URLS.PAYMENT}${API_CONFIG.ENDPOINTS.STORE_DATA}?${queryParams.toString()}`
}

export function buildPartialSaveUrl(params = {}) {
  const { userId, group = API_CONFIG.GROUP, mergeTableKeys } = params
  const queryParams = new URLSearchParams({
    group,
    ...(userId && { userId }),
    ...(mergeTableKeys && { mergeTableKeys }),
  })
  return `${API_CONFIG.BASE_URLS.DATA_STORE}${API_CONFIG.ENDPOINTS.PARTIAL_SAVE}?${queryParams.toString()}`
}

export function buildStatsUrl(storeId, type, subType) {
  const statType = type.toUpperCase()
  return `${API_CONFIG.BASE_URLS.PAYMENT}${API_CONFIG.ENDPOINTS[`STATS_${statType}`]}/${storeId}/all?type=${type}&subType=${subType}&group=${API_CONFIG.GROUP}&service=rapidoo`
}

export function buildBalanceUrl(
  storeId,
  processor = 'currentBalance',
  currency = 'XOF',
) {
  return `${API_CONFIG.BASE_URLS.PAYMENT}${API_CONFIG.ENDPOINTS.WALLET_BALANCE}/${storeId}?service=rapidoo-restaurant&country=BJ&processor=${processor}&currency=${currency}&group=${API_CONFIG.GROUP}`
}

export default API_CONFIG
